
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/openx",
      function () {
        return require("private-next-pages/destinations/openx.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/openx"])
      });
    }
  